interface IFindDaysInAdvanceHealper {
    user: {
        id: string;
    };
    configuration: any;
}

export function findDaysInAdvanceHealper({
    user,
    configuration,
}: IFindDaysInAdvanceHealper) {
    let defaultDaysInAdvance = 7;

    if (Array.isArray(configuration?.itemConfigurations)) {
        const findByUser = configuration.itemConfigurations.find(
            (i: any) => i?.user?.id == user?.id,
        );

        if (findByUser && findByUser?.nextAudience) {
            defaultDaysInAdvance = Number(findByUser.nextAudience);
        }
    }

    return defaultDaysInAdvance;
}
